var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { SESSION_REPLAY_BE } from "../../../../constants";
const sendLarkMessageToGroup = (params) => __async(void 0, null, function* () {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  };
  const res = yield fetch(`${SESSION_REPLAY_BE}/send_lark_message`, requestOptions);
  return {
    status: res.status,
    data: res.status === 200 ? "Success" : "Error"
  };
});
const saveSessionLink = (params) => __async(void 0, null, function* () {
  const url = `${SESSION_REPLAY_BE}/create_oncall_session`;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers,
    body: JSON.stringify(params),
    credentials: "omit"
  };
  try {
    const res = yield fetch(url, requestOptions);
    return {
      status: res.status,
      data: res.status === 200 ? "Success" : "Error"
    };
  } catch (error) {
    console.error("Error updating session link", error);
    return {
      status: 200,
      data: "Error"
    };
  }
});
export {
  saveSessionLink,
  sendLarkMessageToGroup
};
